import { NgModule } from '@angular/core';
import { AnalyticsEventDirectiveModule } from 'idt-analytics-api/directives/analytics-events-directive.module';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { PieceImageTextRenderComponent } from './piece-image-text-render.component';


export const pieceImageTextRenderModuleEntryComponents = [
  PieceImageTextRenderComponent
];

@NgModule({
  imports: [
    LazyLoadModule,
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    AnalyticsEventDirectiveModule
  ],
  declarations: pieceImageTextRenderModuleEntryComponents,
  exports: [PieceImageTextRenderComponent]
})
export class PieceImageTextRenderModule {}

export default pieceImageTextRenderModuleEntryComponents;
